<template>
<div>
  <div class='env-border'>

  </div>
  <div class="env-header">
    <v-flex xs10 offset-xs1 class="vf fl">

    </v-flex>
  </div>
</div>
</template>

<script>
export default {
  name: 'EnvironmentHeader'
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';
.env-border {
  display: block;
  width: 100%;
  height: 0px;
  background-color: $secondary;
}

.env-header {
  display: block;
  background-color: $secondary-darken-2;
  height: 15px;

  p {
    color: #00A0CA;
    position: relative;
    height: 1.6em;
    top: 50%;
    transform: translateY(-50%);

    &.active {
      font-weight: 600;
      color: #fff;
    }

    &.active::before {
      content: "";
      position: absolute;
      background-color: #15acd2;
      height: 2px;
      width: 100%;
      left: 0px;
      top: -12px;
      display: block;
    }
  }
}
</style>
